import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Layout from "./components/layout/Layout";
import Login from "@/pages/Login";
import Dashboard from "./pages/Dashboard";
import Ambitos from "./pages/Ambitos";
import Cohorte from "./pages/Cohorte";
import Estimador from "./pages/Estimador";
import Paciente from "./pages/Paciente";
import Tiempos from "./pages/Tiempos";
import Contactabilidad from "./pages/Contactabilidad";
import Farmacia from "./pages/Farmacia";
import Seguros from "./pages/Seguros";
import Comparativa from "./pages/Comparativa";
import Viaje from "./pages/Viaje";
import Diccionario from "./pages/Diccionario";
import Usuarios from "@/pages/Usuarios";
import Analytics from "@/pages/Analytics";
import Cotizador from "./pages/Cotizador";
import Placeholder from "./pages/Placeholder";
import { trackPageView } from "@/lib/analytics";
import { useEffect } from "react";
import "./App.css";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PageTracker />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/cotizador" element={<ProtectedRoute><Cotizador /></ProtectedRoute>} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/viaje" element={<Viaje />} />
            <Route path="/ambitos" element={<Ambitos />} />
            <Route path="/cohorte" element={<Cohorte />} />
            <Route path="/estimador" element={<Estimador />} />
            <Route path="/paciente" element={<Paciente />} />
            <Route path="/tiempos" element={<Tiempos />} />
            <Route path="/contactabilidad" element={<Contactabilidad />} />
            <Route path="/farmacia" element={<Farmacia />} />
            <Route path="/seguros" element={<Seguros />} />
            <Route path="/comparativa" element={<Comparativa />} />
            <Route path="/configuracion" element={<Placeholder title="Configuración" />} />
            <Route path="/diccionario" element={<Diccionario />} />
            <Route path="/alertas" element={<Placeholder title="Alertas" />} />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/ayuda" element={<Placeholder title="Centro de Ayuda" />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
